var poser = require('./src/node');

module.exports = poser;

['Array', 'Function', 'Object', 'Date', 'String'].forEach(pose);

function pose (type) {
  poser[type] = function poseComputedType () { return poser(type); };
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/poser/index.js
 ** module id = 32
 ** module chunks = 0
 **/